import { fetchApiCreateResourceRelationQuestion } from '@repo/api-codegen';
import { useMutation } from '@tanstack/react-query';
import { queryClient, questionsQueryKeyFactory } from '../../../api';

interface ICreateQuestionEntityRelationArgs {
	questionId: string;
	entityId: string;
}

export async function createQuestionEntityRelation({
	questionId,
	entityId,
}: ICreateQuestionEntityRelationArgs) {
	try {
		await fetchApiCreateResourceRelationQuestion({
			body: {
				from_entity: questionId,
				to_entity: entityId,
			},
		});
		queryClient.invalidateQueries({
			queryKey: questionsQueryKeyFactory.all(),
		});
	} catch (error) {
		throw error;
	}
}

export function useCreateQuestionEntityRelation() {
	return useMutation({
		mutationFn: createQuestionEntityRelation,
	});
}
